// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
// import './AccessPage.css'; // Assuming the CSS is in this file
// import backgroundImage from '../../Assets/Loginbackground.png'; // Import the background image

// export default function Login() {
//   const [formData, setFormData] = useState({ email: '', password: '' });
//   const [errors, setErrors] = useState({});
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//     setErrors({ ...errors, [e.target.name]: '' });
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.email) newErrors.email = 'Email is required';
//     if (!formData.password) newErrors.password = 'Password is required';
//     return newErrors;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const validationErrors = validateForm();
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }

//     // Normally, you would now handle the login logic here, such as checking credentials.
//     // Since we are removing the database connection, you can simulate a successful login like this:
//     const fakeUser = { user_name: 'John Doe' }; // Simulated user
//     alert(`Welcome ${fakeUser.user_name}!`);
//     navigate('/dashboard');
//   };

//   const handleSignupRedirect = () => {
//     navigate('/signup');
//   };

//   const handlefogotpassword = () => {
//     navigate('/forgotpassword');
//   };

//   return (
//     <div className="container-split">
//       <div className="image-half">
//   <img src={backgroundImage} alt="Login Background" className="login-image" />
// </div>

//       <div className="form-half" >
//         <div className="access-container1">
//           <h2 className="access-title">𝐋𝐨𝐠𝐢𝐧</h2>
//           <Form onSubmit={handleSubmit}>
//             <Form.Group controlId="formEmail">
//               <Form.Label>Email</Form.Label>
//               <Form.Control
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 placeholder="Enter Email"
//                 isInvalid={!!errors.email}
//               />
//               <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
//             </Form.Group>

//             <Form.Group controlId="formPassword">
//               <Form.Label>Password</Form.Label>
//               <Form.Control
//                 type="password"
//                 name="password"
//                 value={formData.password}
//                 onChange={handleChange}
//                 placeholder="Enter Password"
//                 isInvalid={!!errors.password}
//               />
//               <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
//             </Form.Group>

//             <Button variant="primary" type="submit" className="button1">
//               Sign In
//             </Button>
//           </Form>

//           <div className="bottom mt-3">
//             <p className="account">
//               Don't have an Account?{' '}
//               <Button
//                 className="signuphyperlink"
//                 variant="link"
//                 onClick={handleSignupRedirect}
//               >
//                 Sign Up Here
//               </Button>
//             </p>

//             <p >
//               <Button
//                 className="forgotpasswordlink"
//                 variant="link"
//                 onClick={handlefogotpassword}
//               >
//                 Forgot Password?
//               </Button>
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import './AccessPage.css'; // Assuming the CSS is in this file
import backgroundImage from '../../Assets/Loginbackground.png'; // Import the background image
import axios from "axios";




export default function Login() {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});
  const [serverError, setServerError] = useState('');
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
    setServerError(''); // Clear server error when user types
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.password) newErrors.password = 'Password is required';
    return newErrors;
  };

  
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
  
    try {
      const response = await axios.post(`${API_BASE_URL}/login`, formData);

      const data = response.data;
      localStorage.setItem("user", JSON.stringify(data));
      localStorage.setItem("role", data.user_role);
      localStorage.setItem("user_id", data.user_id);
      localStorage.setItem("user_name", data.user_name);
  
      alert(`Welcome ${data.user_name}!`);
      navigate("/dashboard");
    } catch (error) {
      if (error.response) {
        setServerError(error.response.data.message || "Invalid credentials");
      } else {
        setServerError("Something went wrong. Please try again.");
      }
    }
  };

  const handleSignupRedirect = () => {
    navigate('/signup');
  };

  const handleForgotPassword = () => {
    navigate('/forgotpassword');
  };

  return (
    <div className="container-split">
      <div className="image-half">
        <img src={backgroundImage} alt="Login Background" className="login-image" />
      </div>

      <div className="form-half">
        <div className="access-container1">
          <h2 className="access-title">𝐋𝐨𝐠𝐢𝐧</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter Email"
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter Password"
                isInvalid={!!errors.password}
              />
              <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
            </Form.Group>

            {serverError && <p className="text-danger mt-2">{serverError}</p>}

            <Button variant="primary" type="submit" className="button1">
              Sign In
            </Button>
          </Form>

          <div className="bottom mt-3">
            <p className="account">
              Don't have an Account?{' '}
              <Button
                className="signuphyperlink"
                variant="link"
                onClick={handleSignupRedirect}
              >
                Sign Up Here
              </Button>
            </p>

            <p>
              <Button
                className="forgotpasswordlink"
                variant="link"
                onClick={handleForgotPassword}
              >
                Forgot Password?
              </Button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
